import React from 'react'
import { Alert } from '@paintscout/ui'
import type { PresentationHelpProps } from '../../'

export default function Help(_: PresentationHelpProps) {
  return (
    <Alert
      severity="info"
      content="Use this section to add any important information you want your customers to see. It will appear with one title and two columns. These columns can either be text or images/videos."
    />
  )
}
